import { RegulationDto } from "api"
import styled from "styled-components"
import safetyColors from "./safetyColors"

const StyledCellDiv = styled.div`
  margin-top: 30px;
  width: 95%;
  ${(p) => p.theme.breakpoints.down("sm")} {
    width: 100%;
  }
  th,
  td {
    border: 1px solid ${(p) => p.theme.colors.darkGrey};
    padding: 5px;
    font-size: 11px;
  }
`

const StyledTable = styled.table`
  border-spacing: 0px;
  text-align: center;
  width: 100%;
  color: ${(p) => p.theme.colors.disable};
  thead {
    background: ${(p) => p.theme.colors.borderGrey};
    color: ${(p) => p.theme.colors.black};
  }
`

const StyledTh = styled.th`
  font-size: 11px;
  font-weight: 400;
`

type SafetyTableProps = {
  data: RegulationDto
}

const SafetyTable = ({ data }: SafetyTableProps) => {
  return (
    <StyledCellDiv>
      <StyledTable>
        <thead>
          <tr>
            <StyledTh colSpan={1} scope="colgroup">
              קוד דגם
            </StyledTh>
            <StyledTh colSpan={1} scope="colgroup">
              תיאור דגם
            </StyledTh>
            <StyledTh colSpan={1} scope="colgroup">
              רמת האבזור הבטיחותי
            </StyledTh>
          </tr>
        </thead>
        <tbody>
          {data?.safetyTable.map((item, i) => (
            <tr key={i}>
              <td>{item.finishingLevelCode}</td>
              <td>{item.finishingLevelFullName}</td>
              <td
                style={{
                  background: safetyColors[item.safetyLevel],
                  color: "#FFFFFF",
                }}
              >
                {item.safetyLevel}
              </td>
            </tr>
          ))}
        </tbody>
      </StyledTable>
    </StyledCellDiv>
  )
}

export default SafetyTable
